import * as actionTypes from 'ActionTypes';
import { updateObj } from 'Utils';

const initialState = {
	playlist: [],
	activeTrack: null,
	activeTrackId: null,
	isReady: false,
	isPlaying: false,
	progressLoaded: 0,
	progressCompleted: 0,
	duration: null
};

export const PlayerReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_ACTIVE_TRACK:
			return updateObj(state, { activeTrack: action.activeTrack });
		case actionTypes.SET_ACTIVE_TRACK_ID:
			return updateObj(state, { activeTrackId: action.activeTrackId });
		case actionTypes.SET_IS_PLAYING:
			return updateObj(state, { isPlaying: action.isPlaying });
		case actionTypes.SET_READY_STATE:
			return updateObj(state, { isReady: action.isReady });
		case actionTypes.SET_DURATION:
			return updateObj(state, { duration: action.duration });
		case actionTypes.SET_PROGRESS_LOADED:
			return updateObj(state, { progressLoaded: action.progressLoaded });
		case actionTypes.SET_PROGRESS_COMPLETED:
			return updateObj(state, {
				progressCompleted: action.progressCompleted
			});
		case actionTypes.SET_IN_PLAYLIST:
			return updateObj(state, { playlist: action.playlist });
		case actionTypes.SET_IN_TRACKLIST:
			return updateObj(state, { trackList: action.trackList });
		default:
			return state;
	}
};
